function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturnsExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6382"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41177",
    d: "M79.694 975.665h5.58a1.639 1.639 0 0 1 1.8 1.789v11.254A1.636 1.636 0 0 1 85.3 990.5H74.02a1.632 1.632 0 0 1-1.773-1.759v-11.316a1.631 1.631 0 0 1 1.774-1.757q2.836-.005 5.673-.003z",
    transform: "translate(-63.694 -967.113)",
    style: {
      fill: "#283045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41178",
    d: "M-6.073 915.583c.117-.712.222-1.346.325-1.981.066-.4.325-.634.663-.582a.579.579 0 0 1 .464.747q-.253 1.614-.523 3.225a.565.565 0 0 1-.708.521q-1.645-.256-3.286-.533a.585.585 0 0 1-.526-.682.587.587 0 0 1 .733-.448q.859.143 1.72.281a.236.236 0 0 0 .064-.008c.022-.095-.054-.147-.1-.211a14.153 14.153 0 0 1-2.422-9.147 14.262 14.262 0 0 1 19.869-11.95.663.663 0 0 1 .478.521.567.567 0 0 1-.806.583 14 14 0 0 0-2.234-.756 12.86 12.86 0 0 0-11.332 2.549 12.519 12.519 0 0 0-4.706 8.226 12.94 12.94 0 0 0 2.241 9.516z",
    transform: "translate(11.431 -891.931)",
    style: {
      fill: "#283045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41179",
    d: "m104.3 951.134-.327 1.98c-.064.386-.318.611-.644.572a.575.575 0 0 1-.483-.733q.253-1.629.531-3.255a.554.554 0 0 1 .717-.5q1.63.252 3.256.526a.579.579 0 1 1-.216 1.128c-.582-.1-1.165-.191-1.773-.29a.628.628 0 0 0 .156.3A14.258 14.258 0 0 1 88 971.877a.59.59 0 0 1-.4-.788c.13-.325.463-.43.866-.258a13.243 13.243 0 0 0 5.358 1.079 13.022 13.022 0 0 0 12.072-8.351 12.863 12.863 0 0 0-1.418-12.2c-.047-.059-.093-.114-.178-.225z",
    transform: "translate(-77.719 -942.836)",
    style: {
      fill: "#283045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41180",
    d: "M92.067 1039.41h-5.486c-.644 0-.776-.129-.776-.76 0-2.67 0-5.341-.007-8.011 0-.3.081-.385.381-.378.924.019 1.849.014 2.774 0 .219 0 .287.063.28.281-.015.425-.006.852 0 1.278 0 .64.393.889.959.61s1.117-.55 1.669-.838a.446.446 0 0 1 .462 0c.561.293 1.128.574 1.7.852.519.254.915.012.926-.567q.013-.67 0-1.34c0-.188.03-.279.252-.276.977.011 1.953.009 2.93 0 .2 0 .247.071.247.255 0 2.764 0 5.527-.005 8.291 0 .441-.192.6-.686.6q-2.815.005-5.62.003z",
    transform: "translate(-76.116 -1017.159)",
    style: {
      fill: "#00a6c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41181",
    d: "M144.175 991.374c0 .612-.005 1.224 0 1.836 0 .207-.041.265-.242.157-.355-.191-.724-.359-1.08-.549a.746.746 0 0 0-.766 0c-.345.189-.7.353-1.052.536-.174.091-.273.124-.271-.146.01-1.234.007-2.469 0-3.7 0-.169.045-.239.227-.238q1.478.01 2.956 0c.183 0 .228.07.226.239-.002.62.002 1.242.002 1.865z",
    transform: "translate(-126.504 -979.582)",
    style: {
      fill: "#faf871"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41182",
    d: "M87.58 991.544c-.5 0-1-.006-1.5 0-.17 0-.239-.039-.235-.223.011-.5 0-1 .006-1.5.007-.394.182-.569.581-.572.873-.007 1.745 0 2.618-.006.185 0 .226.07.224.238-.007.613-.01 1.226 0 1.839 0 .186-.067.224-.235.221-.482-.002-.971.003-1.459.003z",
    transform: "translate(-76.162 -979.566)",
    style: {
      fill: "#84e681"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41183",
    d: "M197.165 991.545c-.488 0-.977-.007-1.465 0-.174 0-.234-.044-.231-.225.01-.613.009-1.226 0-1.839 0-.173.048-.235.229-.234.873.008 1.745 0 2.618.006.4 0 .571.182.577.576.008.5-.006 1 .006 1.5 0 .191-.076.221-.24.219-.497-.008-.995-.003-1.494-.003z",
    transform: "translate(-176.648 -979.567)",
    style: {
      fill: "#84e681"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41184",
    d: "M129.855 1113.676h-2.182c-.414 0-.677-.228-.672-.569s.27-.56.687-.561h4.332c.419 0 .682.219.688.56s-.262.569-.7.57h-2.153z",
    transform: "translate(-113.885 -1092.586)",
    style: {
      fill: "#283045"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnsExchange);
export default __webpack_public_path__ + "static/media/ReturnsExchange.fa1ea29cf53369851ad8968483b63078.svg";
export { ForwardRef as ReactComponent };